export enum EVENT_TYPE_COLUMN_NAME {
  ID = "id",
  NAME = "name",
  CATEGORY = "category",
  DESCRIPTION = "description",
}

export enum EVENT_TYPE_LABEL_NAME {
  ID = "ID",
  NAME = "Name",
  CATEGORY = "Category",
  DESCRIPTION = "Description",
}

export const EVENT_TYPE_FILTER_COLUMN_OPTIONS = [
  {
    label: EVENT_TYPE_LABEL_NAME.NAME,
    value: EVENT_TYPE_COLUMN_NAME.NAME,
  },
  {
    label: EVENT_TYPE_LABEL_NAME.CATEGORY,
    value: EVENT_TYPE_COLUMN_NAME.CATEGORY,
  },
];
